// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var DomUtils = require("../../../../shared/src/DomUtils.bs.js");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var FormalityCompat = require("re-formality/src/FormalityCompat.bs.js");
var Relude_Js_Promise = require("relude/src/js/Relude_Js_Promise.bs.js");
var CommonTypes_User_Name = require("../../../../shared/src/types/CommonTypes_User_Name.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Image = require("../../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Input = require("../../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_Subtext = require("../../../../shared-browser/src/components/BrowserComponents_Subtext.bs.js");
var BrowserComponents_Dropdown = require("../../../../shared-browser/src/components/BrowserComponents_Dropdown.bs.js");
var BrowserComponents_Textarea = require("../../../../shared-browser/src/components/BrowserComponents_Textarea.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var CommonTypes_Shift_DressCode = require("../../../../shared/src/types/CommonTypes_Shift_DressCode.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var CommonTypes_Business_Manager = require("../../../../shared/src/types/business/CommonTypes_Business_Manager.bs.js");
var WebComponents_PostAShiftForm = require("../../components/WebComponents_PostAShiftForm.bs.js");
var CommonTypes_ShiftType_Accessory = require("../../../../shared/src/types/CommonTypes_ShiftType_Accessory.bs.js");
var BrowserComponents_ValidationError = require("../../../../shared-browser/src/components/BrowserComponents_ValidationError.bs.js");
var FormalityCompat__FormAsyncOnChange = require("re-formality/src/FormalityCompat__FormAsyncOnChange.bs.js");

var descText = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Medium */3, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: {
            hd: BrowserStyle.textAlign("center"),
            tl: /* [] */0
          }
        }));

var descriptionInput = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(7.5)),
      tl: {
        hd: BrowserStyle.resize(BrowserStyle.none),
        tl: /* [] */0
      }
    });

var dressCodeContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.stretch),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.center),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.flexDirection(BrowserStyle.column),
                tl: {
                  hd: BrowserStyle.justifyContent(BrowserStyle.stretch),
                  tl: /* [] */0
                }
              }),
          tl: /* [] */0
        }
      }
    });

var accessoryContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.stretch),
      tl: {
        hd: BrowserStyle.flexWrap("wrap"),
        tl: {
          hd: BrowserStyle.justifyContent(BrowserStyle.center),
          tl: /* [] */0
        }
      }
    });

var accessory = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.margin(BrowserStyle.Spacing.xSmall),
      tl: /* [] */0
    });

var managerContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.mobileMedia({
            hd: BrowserStyle.flexDirection(BrowserStyle.column),
            tl: /* [] */0
          }),
      tl: /* [] */0
    });

var managerInput = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.flexBasis(BrowserStyle.zero),
        tl: /* [] */0
      }
    });

var Styles = {
  descText: descText,
  descriptionInput: descriptionInput,
  dressCodeContainer: dressCodeContainer,
  accessoryContainer: accessoryContainer,
  accessory: accessory,
  managerContainer: managerContainer,
  managerInput: managerInput
};

var selector = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.margin2(BrowserStyle.zero, BrowserStyle.Spacing.xSmall),
      tl: {
        hd: BrowserStyle.mobileMedia({
              hd: BrowserStyle.flex({
                    NAME: "num",
                    VAL: 1.0
                  }),
              tl: {
                hd: BrowserStyle.margin2(BrowserStyle.Spacing.xSmall, BrowserStyle.zero),
                tl: /* [] */0
              }
            }),
        tl: /* [] */0
      }
    });

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.xLarge),
      tl: {
        hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.xLarge),
        tl: /* [] */0
      }
    });

var innerContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.mobileMedia({
              hd: BrowserStyle.flexDirection(BrowserStyle.row),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var image = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(3.0)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.rem(2.5)),
        tl: /* [] */0
      }
    });

function arg(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Large */4, /* Bold */2);
}

var name = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.mobileMedia(Curry._1(arg(undefined, undefined), {
                hd: BrowserStyle.marginLeft(BrowserStyle.Spacing.small),
                tl: /* [] */0
              })),
      tl: /* [] */0
    });

var Styles$1 = {
  selector: selector,
  container: container,
  innerContainer: innerContainer,
  image: image,
  name: name
};

function WebContainers_PostAShift_ShiftDetails$DressCodeButton(Props) {
  var dressCode = Props.dressCode;
  var isSelected = Props.isSelected;
  var onClick = Props.onClick;
  var tmp;
  if (typeof dressCode === "number") {
    switch (dressCode) {
      case /* BlackOnBlack */0 :
          tmp = "BlackOnBlack";
          break;
      case /* WhiteOnBlack */1 :
          tmp = "WhiteOnBlack";
          break;
      case /* Custom */2 :
          tmp = "Custom";
          break;
      
    }
  } else {
    tmp = dressCode._0;
  }
  return React.createElement(BrowserComponents_Button.Selector.make, {
              className: selector,
              children: React.createElement(BrowserComponents_FlexColumn.make, {
                    className: innerContainer,
                    children: null
                  }, React.createElement(BrowserComponents_Image.make, {
                        className: image,
                        image: {
                          TAG: /* Illustration */1,
                          _0: {
                            TAG: /* DressCode */0,
                            _0: dressCode
                          }
                        }
                      }), React.createElement(BrowserComponents_Text.make, {
                        className: name,
                        children: CommonTypes_Shift_DressCode.toString(dressCode)
                      })),
              containerClassName: container,
              isSelected: isSelected,
              onClick: (function (param) {
                  return Curry._1(onClick, dressCode);
                }),
              testId: "DressCode" + tmp
            });
}

var DressCodeButton = {
  Styles: Styles$1,
  make: WebContainers_PostAShift_ShiftDetails$DressCodeButton
};

function initialState(basicInfo, savedManagers, phoneNumberIsAvailable) {
  return {
          accessories: CommonTypes_ShiftType_Accessory.$$Set.empty,
          attire: "",
          copiedFrom: undefined,
          description: "",
          dressCode: /* BlackOnBlack */0,
          onsiteManagerFirstName: "",
          onsiteManagerLastName: "",
          onsiteManagerPhoneNumber: "",
          phoneNumberIsAvailable: phoneNumberIsAvailable,
          savedManagers: savedManagers,
          selectedManager: undefined,
          shiftType: Relude_Option.map((function (param) {
                  return param.shiftType;
                }), basicInfo)
        };
}

function fromNewShiftDetails(basicInfo, savedManagers, phoneNumberIsAvailable, param) {
  return {
          accessories: param.accessories,
          attire: param.attire,
          copiedFrom: param.copiedFrom,
          description: param.description,
          dressCode: param.dressCode,
          onsiteManagerFirstName: param.onsiteManagerFirstName,
          onsiteManagerLastName: param.onsiteManagerLastName,
          onsiteManagerPhoneNumber: CommonTypes_LongPhoneNumber.toFormattedString(param.onsiteManagerPhoneNumber),
          phoneNumberIsAvailable: phoneNumberIsAvailable,
          savedManagers: savedManagers,
          selectedManager: param.selectedManager,
          shiftType: Relude_Option.map((function (param) {
                  return param.shiftType;
                }), basicInfo)
        };
}

var debounceInterval = FormalityCompat.Async.debounceInterval;

function get(param) {
  return param.dressCode;
}

function update(setState, state, dressCode) {
  return Curry._2(setState, /* DressCode */0, {
              accessories: state.accessories,
              attire: state.attire,
              copiedFrom: state.copiedFrom,
              description: state.description,
              dressCode: dressCode,
              onsiteManagerFirstName: state.onsiteManagerFirstName,
              onsiteManagerLastName: state.onsiteManagerLastName,
              onsiteManagerPhoneNumber: state.onsiteManagerPhoneNumber,
              phoneNumberIsAvailable: state.phoneNumberIsAvailable,
              savedManagers: state.savedManagers,
              selectedManager: state.selectedManager,
              shiftType: state.shiftType
            });
}

var partial_arg = Relude_Result.ok(/* Valid */0);

var validator_dependents = Relude_Option.pure({
      hd: /* Attire */1,
      tl: /* [] */0
    });

function validator_validate(param) {
  return Relude_Globals.$$const(partial_arg, param);
}

var validator = {
  field: /* DressCode */0,
  strategy: /* OnFirstChange */1,
  dependents: validator_dependents,
  validate: validator_validate,
  validateAsync: undefined
};

var DressCodeField = {
  get: get,
  update: update,
  validator: validator
};

function get$1(param) {
  return param.attire;
}

function update$1(setState, state, attire) {
  return Curry._2(setState, /* Attire */1, {
              accessories: state.accessories,
              attire: attire,
              copiedFrom: state.copiedFrom,
              description: state.description,
              dressCode: state.dressCode,
              onsiteManagerFirstName: state.onsiteManagerFirstName,
              onsiteManagerLastName: state.onsiteManagerLastName,
              onsiteManagerPhoneNumber: state.onsiteManagerPhoneNumber,
              phoneNumberIsAvailable: state.phoneNumberIsAvailable,
              savedManagers: state.savedManagers,
              selectedManager: state.selectedManager,
              shiftType: state.shiftType
            });
}

function validator_validate$1(param) {
  var match = param.dressCode;
  if (typeof match === "number") {
    if (match >= 2) {
      return Relude_Result.fromOption("Must specific an attire if a custom dress code is being used", Relude_Option.map((function (param) {
                        return Relude_Globals.$$const(/* Valid */0, param);
                      }), Relude_String.toNonWhitespace(param.attire)));
    } else {
      return Relude_Result.ok(/* Valid */0);
    }
  } else {
    return Relude_Result.error("Unknow value for dress code");
  }
}

var validator$1 = {
  field: /* Attire */1,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$1,
  validateAsync: undefined
};

var AttireField = {
  get: get$1,
  update: update$1,
  validator: validator$1
};

function get$2(param) {
  return param.accessories;
}

function update$2(setState, state, accessories) {
  return Curry._2(setState, /* Accessories */2, {
              accessories: accessories,
              attire: state.attire,
              copiedFrom: state.copiedFrom,
              description: state.description,
              dressCode: state.dressCode,
              onsiteManagerFirstName: state.onsiteManagerFirstName,
              onsiteManagerLastName: state.onsiteManagerLastName,
              onsiteManagerPhoneNumber: state.onsiteManagerPhoneNumber,
              phoneNumberIsAvailable: state.phoneNumberIsAvailable,
              savedManagers: state.savedManagers,
              selectedManager: state.selectedManager,
              shiftType: state.shiftType
            });
}

function addAccessory(setState, state, accessoryToAdd) {
  return update$2(setState, state, Curry._2(CommonTypes_ShiftType_Accessory.$$Set.add, accessoryToAdd, get$2(state)));
}

function removeAccessory(setState, state, accessoryToRemove) {
  return update$2(setState, state, Curry._2(CommonTypes_ShiftType_Accessory.$$Set.remove, accessoryToRemove, get$2(state)));
}

function toggleAccesory(setState, state, accessoryToToggle) {
  if (Curry._2(CommonTypes_ShiftType_Accessory.$$Set.contains, accessoryToToggle, get$2(state))) {
    return removeAccessory(setState, state, accessoryToToggle);
  } else {
    return addAccessory(setState, state, accessoryToToggle);
  }
}

var AccessoriesField = {
  get: get$2,
  update: update$2,
  addAccessory: addAccessory,
  removeAccessory: removeAccessory,
  toggleAccesory: toggleAccesory
};

function get$3(param) {
  return param.selectedManager;
}

function update$3(setState, state, selectedManager) {
  var newState_accessories = state.accessories;
  var newState_attire = state.attire;
  var newState_copiedFrom = state.copiedFrom;
  var newState_description = state.description;
  var newState_dressCode = state.dressCode;
  var newState_onsiteManagerFirstName = state.onsiteManagerFirstName;
  var newState_onsiteManagerLastName = state.onsiteManagerLastName;
  var newState_onsiteManagerPhoneNumber = state.onsiteManagerPhoneNumber;
  var newState_phoneNumberIsAvailable = state.phoneNumberIsAvailable;
  var newState_savedManagers = state.savedManagers;
  var newState_shiftType = state.shiftType;
  var newState = {
    accessories: newState_accessories,
    attire: newState_attire,
    copiedFrom: newState_copiedFrom,
    description: newState_description,
    dressCode: newState_dressCode,
    onsiteManagerFirstName: newState_onsiteManagerFirstName,
    onsiteManagerLastName: newState_onsiteManagerLastName,
    onsiteManagerPhoneNumber: newState_onsiteManagerPhoneNumber,
    phoneNumberIsAvailable: newState_phoneNumberIsAvailable,
    savedManagers: newState_savedManagers,
    selectedManager: selectedManager,
    shiftType: newState_shiftType
  };
  Curry._2(setState, /* SelectedManager */3, newState);
  Curry._2(setState, /* OnsiteManagerFirstName */4, newState);
  Curry._2(setState, /* OnsiteManagerLastName */5, newState);
  return Curry._2(setState, /* OnsiteManagerPhoneNumber */6, newState);
}

var getSavedManager = Reselect.createSelector2(undefined, get$3, (function (param) {
        return param.savedManagers;
      }), (function (selectedManager, savedManagers) {
        return Curry._2(Relude_Option.flatMap, (function (manager) {
                      return Relude_Set.get(manager, savedManagers);
                    }), selectedManager);
      }));

var partial_arg$1 = Relude_Result.ok(/* Valid */0);

var validator_dependents$1 = Relude_Option.pure({
      hd: /* OnsiteManagerFirstName */4,
      tl: {
        hd: /* OnsiteManagerLastName */5,
        tl: {
          hd: /* OnsiteManagerPhoneNumber */6,
          tl: /* [] */0
        }
      }
    });

function validator_validate$2(param) {
  return Relude_Globals.$$const(partial_arg$1, param);
}

var validator$2 = {
  field: /* SelectedManager */3,
  strategy: /* OnFirstChange */1,
  dependents: validator_dependents$1,
  validate: validator_validate$2,
  validateAsync: undefined
};

var SelectedManagerField = {
  get: get$3,
  update: update$3,
  getSavedManager: getSavedManager,
  validator: validator$2
};

var get$4 = Reselect.createSelector2(undefined, (function (param) {
        return param.onsiteManagerFirstName;
      }), getSavedManager, (function (onsiteManagerFirstName, savedManagers) {
        return Relude_Option.fold(onsiteManagerFirstName, (function (param) {
                      return Curry._1(CommonTypes_User_Name.FirstName.toString, param.name.firstName);
                    }), savedManagers);
      }));

function update$4(setState, state, onsiteManagerFirstName) {
  return Curry._2(setState, /* OnsiteManagerFirstName */4, {
              accessories: state.accessories,
              attire: state.attire,
              copiedFrom: state.copiedFrom,
              description: state.description,
              dressCode: state.dressCode,
              onsiteManagerFirstName: onsiteManagerFirstName,
              onsiteManagerLastName: state.onsiteManagerLastName,
              onsiteManagerPhoneNumber: state.onsiteManagerPhoneNumber,
              phoneNumberIsAvailable: state.phoneNumberIsAvailable,
              savedManagers: state.savedManagers,
              selectedManager: state.selectedManager,
              shiftType: state.shiftType
            });
}

function validator_validate$3(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$4, Relude_String.toNonWhitespace, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption("Enter a first name", param);
              }), param);
}

var validator$3 = {
  field: /* OnsiteManagerFirstName */4,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$3,
  validateAsync: undefined
};

var OnsiteManagerFirstNameField = {
  get: get$4,
  update: update$4,
  validator: validator$3
};

var get$5 = Reselect.createSelector2(undefined, (function (param) {
        return param.onsiteManagerLastName;
      }), getSavedManager, (function (onsiteManagerLastName, savedManagers) {
        return Relude_Option.fold(onsiteManagerLastName, (function (param) {
                      return Curry._1(CommonTypes_User_Name.LastName.toString, param.name.lastName);
                    }), savedManagers);
      }));

function update$5(setState, state, onsiteManagerLastName) {
  return Curry._2(setState, /* OnsiteManagerLastName */5, {
              accessories: state.accessories,
              attire: state.attire,
              copiedFrom: state.copiedFrom,
              description: state.description,
              dressCode: state.dressCode,
              onsiteManagerFirstName: state.onsiteManagerFirstName,
              onsiteManagerLastName: onsiteManagerLastName,
              onsiteManagerPhoneNumber: state.onsiteManagerPhoneNumber,
              phoneNumberIsAvailable: state.phoneNumberIsAvailable,
              savedManagers: state.savedManagers,
              selectedManager: state.selectedManager,
              shiftType: state.shiftType
            });
}

function validator_validate$4(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$5, Relude_String.toNonWhitespace, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption("Enter a last name", param);
              }), param);
}

var validator$4 = {
  field: /* OnsiteManagerLastName */5,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$4,
  validateAsync: undefined
};

var OnsiteManagerLastNameField = {
  get: get$5,
  update: update$5,
  validator: validator$4
};

var get$6 = Reselect.createSelector2(undefined, (function (param) {
        return param.onsiteManagerPhoneNumber;
      }), getSavedManager, (function (onsiteManagerPhoneNumber, savedManagers) {
        return Relude_Option.fold(onsiteManagerPhoneNumber, (function (param) {
                      return CommonTypes_LongPhoneNumber.toString(param.phoneNumber);
                    }), savedManagers);
      }));

function update$6(setState, state, onsiteManagerPhoneNumber) {
  return Curry._2(setState, /* OnsiteManagerPhoneNumber */6, {
              accessories: state.accessories,
              attire: state.attire,
              copiedFrom: state.copiedFrom,
              description: state.description,
              dressCode: state.dressCode,
              onsiteManagerFirstName: state.onsiteManagerFirstName,
              onsiteManagerLastName: state.onsiteManagerLastName,
              onsiteManagerPhoneNumber: onsiteManagerPhoneNumber,
              phoneNumberIsAvailable: state.phoneNumberIsAvailable,
              savedManagers: state.savedManagers,
              selectedManager: state.selectedManager,
              shiftType: state.shiftType
            });
}

var invalidPhoneMessage = "Enter a valid phone number";

var phoneNumberTakenMessage = "That phone number is already taken";

var getNewOnsiteManagerPhoneNumberIsAvailable = Reselect.createSelector2(undefined, (function (param) {
        return param.onsiteManagerPhoneNumber;
      }), (function (param) {
        return param.phoneNumberIsAvailable;
      }), (function (onsiteManagerPhoneNumber, phoneNumberIsAvailable) {
        return Relude_Option.fold(Relude_IO.pure(Relude_Result.error(invalidPhoneMessage)), (function (param) {
                      return Relude_Globals.$great$great(phoneNumberIsAvailable, (function (param) {
                                    return Relude_IO.map((function (isPhoneNumberAvailable) {
                                                  if (isPhoneNumberAvailable) {
                                                    return Relude_Result.ok(/* Valid */0);
                                                  } else {
                                                    return Relude_Result.error(phoneNumberTakenMessage);
                                                  }
                                                }), param);
                                  }), param);
                    }), CommonTypes_LongPhoneNumber.fromString(onsiteManagerPhoneNumber));
      }));

var getIsPhoneNumberValid = Reselect.createSelector2(undefined, getNewOnsiteManagerPhoneNumberIsAvailable, getSavedManager, (function (newOnsiteManagerPhoneNumberIsAvailable, savedManager) {
        return Relude_Option.fold(newOnsiteManagerPhoneNumberIsAvailable, (function (param) {
                      return Relude_Globals.$great$great((function (param) {
                                    return Relude_Globals.$great$great((function (param) {
                                                  return Relude_Globals.$$const(/* Valid */0, param);
                                                }), Relude_Result.ok, param);
                                  }), Relude_IO.pure, param);
                    }), savedManager);
      }));

function checkIfPhoneNumberIsAvailable(param) {
  return Relude_Option.map(param.phoneNumberIsAvailable, CommonTypes_LongPhoneNumber.fromString(param.onsiteManagerPhoneNumber));
}

function validator_validate$5(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$6, CommonTypes_LongPhoneNumber.fromString, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption(invalidPhoneMessage, param);
              }), param);
}

var validator_validateAsync = [
  (function (param) {
      return Relude_Globals.$great$great(getIsPhoneNumberValid, Relude_Js_Promise.fromIO, param);
    }),
  (function (prev, next) {
      return Relude_String.eq(Curry._1(get$6, prev), Curry._1(get$6, next));
    })
];

var validator$5 = {
  field: /* OnsiteManagerPhoneNumber */6,
  strategy: /* OnFirstChange */1,
  dependents: undefined,
  validate: validator_validate$5,
  validateAsync: validator_validateAsync
};

var OnsiteManagerPhoneNumberField = {
  get: get$6,
  update: update$6,
  invalidPhoneMessage: invalidPhoneMessage,
  phoneNumberTakenMessage: phoneNumberTakenMessage,
  getNewOnsiteManagerPhoneNumberIsAvailable: getNewOnsiteManagerPhoneNumberIsAvailable,
  getIsPhoneNumberValid: getIsPhoneNumberValid,
  checkIfPhoneNumberIsAvailable: checkIfPhoneNumberIsAvailable,
  validator: validator$5
};

function get$7(param) {
  return param.description;
}

function update$7(setState, state, description) {
  return Curry._2(setState, /* Description */7, {
              accessories: state.accessories,
              attire: state.attire,
              copiedFrom: state.copiedFrom,
              description: description,
              dressCode: state.dressCode,
              onsiteManagerFirstName: state.onsiteManagerFirstName,
              onsiteManagerLastName: state.onsiteManagerLastName,
              onsiteManagerPhoneNumber: state.onsiteManagerPhoneNumber,
              phoneNumberIsAvailable: state.phoneNumberIsAvailable,
              savedManagers: state.savedManagers,
              selectedManager: state.selectedManager,
              shiftType: state.shiftType
            });
}

function validator_validate$6(param) {
  return Relude_Result.fromOption("You must have a shift description", Relude_Option.map((function (param) {
                    return Relude_Globals.$$const(/* Valid */0, param);
                  }), Relude_String.toNonWhitespace(param.description)));
}

var validator$6 = {
  field: /* Description */7,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$6,
  validateAsync: undefined
};

var DescriptionField = {
  get: get$7,
  update: update$7,
  validator: validator$6
};

function toNewShiftDetails(state) {
  var selectedManager = state.selectedManager;
  var dressCode = state.dressCode;
  var description = state.description;
  var copiedFrom = state.copiedFrom;
  var attire = state.attire;
  var accessories = state.accessories;
  return Relude_Option.map((function (onsiteManagerPhoneNumber) {
                return {
                        accessories: accessories,
                        attire: Relude_String.trim(attire),
                        copiedFrom: copiedFrom,
                        description: Relude_String.trim(description),
                        dressCode: dressCode,
                        onsiteManagerFirstName: Relude_String.trim(Curry._1(get$4, state)),
                        onsiteManagerLastName: Relude_String.trim(Curry._1(get$5, state)),
                        onsiteManagerPhoneNumber: onsiteManagerPhoneNumber,
                        selectedManager: selectedManager
                      };
              }), CommonTypes_LongPhoneNumber.fromString(Curry._1(get$6, state)));
}

var validators_1 = {
  hd: validator$1,
  tl: {
    hd: validator$3,
    tl: {
      hd: validator$4,
      tl: {
        hd: validator$5,
        tl: {
          hd: validator$6,
          tl: {
            hd: validator$2,
            tl: /* [] */0
          }
        }
      }
    }
  }
};

var validators = {
  hd: validator,
  tl: validators_1
};

var Form = {
  initialState: initialState,
  fromNewShiftDetails: fromNewShiftDetails,
  debounceInterval: debounceInterval,
  DressCodeField: DressCodeField,
  AttireField: AttireField,
  AccessoriesField: AccessoriesField,
  SelectedManagerField: SelectedManagerField,
  OnsiteManagerFirstNameField: OnsiteManagerFirstNameField,
  OnsiteManagerLastNameField: OnsiteManagerLastNameField,
  OnsiteManagerPhoneNumberField: OnsiteManagerPhoneNumberField,
  DescriptionField: DescriptionField,
  toNewShiftDetails: toNewShiftDetails,
  validators: validators
};

var FormContainer = FormalityCompat__FormAsyncOnChange.Make({
      debounceInterval: debounceInterval,
      validators: validators
    });

function getSavedManagerOrState(state, savedManagers) {
  return Relude_Option.fold(state, (function (manager) {
                var match = manager.name;
                return {
                        accessories: state.accessories,
                        attire: state.attire,
                        copiedFrom: state.copiedFrom,
                        description: state.description,
                        dressCode: state.dressCode,
                        onsiteManagerFirstName: Curry._1(CommonTypes_User_Name.FirstName.toString, match.firstName),
                        onsiteManagerLastName: Curry._1(CommonTypes_User_Name.LastName.toString, match.lastName),
                        onsiteManagerPhoneNumber: CommonTypes_LongPhoneNumber.toString(manager.phoneNumber),
                        phoneNumberIsAvailable: state.phoneNumberIsAvailable,
                        savedManagers: state.savedManagers,
                        selectedManager: Relude_Option.pure(manager),
                        shiftType: state.shiftType
                      };
              }), Curry._2(Relude_Option.flatMap, (function (manager) {
                    return Relude_Set.get(manager, savedManagers);
                  }), state.selectedManager));
}

function getDressCodeDescription(param) {
  if (typeof param !== "number") {
    return ;
  }
  switch (param) {
    case /* BlackOnBlack */0 :
        return "Black button down shirt, black pants, black non-slip shoes";
    case /* WhiteOnBlack */1 :
        return "White button down shirt, black pants, black non-slip shoes";
    case /* Custom */2 :
        return "Enter your custom attire into the Special Attire Notes below";
    
  }
}

function WebContainers_PostAShift_ShiftDetails(Props) {
  var goBack = Props.goBack;
  var param = Props.newShift;
  var phoneNumberIsAvailable = Props.phoneNumberIsAvailable;
  var savedManagers = Props.savedManagers;
  var setDetails = Props.setDetails;
  var basicInfo = param.basicInfo;
  var match = Curry._2(FormContainer.useForm, Relude_Option.fold(initialState(basicInfo, savedManagers, phoneNumberIsAvailable), (function (param) {
              return fromNewShiftDetails(basicInfo, savedManagers, phoneNumberIsAvailable, param);
            }), param.details), (function (state, param) {
          var notifyOnFailure = param.notifyOnFailure;
          return Relude_Option.foldLazy((function (param) {
                        return Curry._1(notifyOnFailure, /* ValidationError */0);
                      }), (function (param) {
                        return Relude_Globals.$great$great(setDetails, (function (param) {
                                      return Relude_IO.unsafeRunAsync((function (param) {
                                                    return Relude_Result.fold(Relude_Globals.id, Relude_Globals.id, param);
                                                  }), param);
                                    }), param);
                      }), toNewShiftDetails(state));
        }));
  var blur = match.blur;
  var change = match.change;
  var result = match.result;
  var state = match.state;
  var selectedManager = state.selectedManager;
  var dressCode = state.dressCode;
  var accessories = state.accessories;
  var updateDressCode = function (dressCode) {
    return Relude_IO.suspend(function (param) {
                return update(change, state, dressCode);
              });
  };
  ReactIO.useHandledIOOnMount(undefined)(DomUtils.$$Window.scrollToTop);
  var partial_arg = {
    TAG: /* Navigation */5,
    _0: /* Profile */8
  };
  var partial_arg$1 = get$3(state);
  var tmp = {
    icon: Relude_Option.fold({
          TAG: /* Status */8,
          _0: /* CirclePlus */8
        }, (function (param) {
            return Relude_Globals.$$const(partial_arg, param);
          }), get$3(state)),
    isItemSelected: (function (param) {
        return Relude_Option.eqBy(CommonTypes_Business_Manager.eq, partial_arg$1, param);
      }),
    items: {
      TAG: /* Set */2,
      _0: Curry._1(CommonTypes_Business_Manager.SetWithNone.fromSet, savedManagers)
    },
    itemToDisplayString: (function (param) {
        return Relude_Option.fold("Add New Manager", (function (param) {
                      return CommonTypes_User_Name.toString(param.name) + (" - " + CommonTypes_LongPhoneNumber.toString(param.phoneNumber));
                    }), param);
      }),
    onBlur: Relude_IO.suspend(function (param) {
          return Curry._1(blur, /* SelectedManager */3);
        }),
    onSelectItem: (function (param) {
        return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                      return Relude_IO.map((function (param) {
                                    return update$3(change, state, param);
                                  }), param);
                    }), param);
      }),
    testId: "ManagerSelector" + Relude_Option.fold("", (function (param) {
            return Curry._1(CommonTypes_Business_Manager.Id.toString, param.id);
          }), getSavedManagerOrState(state, savedManagers).selectedManager),
    title: "Select Manager"
  };
  var tmp$1 = Curry._1(result, /* SelectedManager */3);
  if (tmp$1 !== undefined) {
    tmp.validationStatus = Caml_option.valFromOption(tmp$1);
  }
  var partial_arg$2 = null;
  return React.createElement(WebComponents_PostAShiftForm.LegacyForm.make, {
              children: null,
              onBackButtonClick: goBack,
              submit: match.submit,
              subtitle: "Our Professionals will arrive to the shift looking prepared.",
              testIdPrefix: "",
              title: "Attire"
            }, React.createElement(BrowserComponents_FlexRow.make, {
                  className: dressCodeContainer,
                  children: null
                }, React.createElement(WebContainers_PostAShift_ShiftDetails$DressCodeButton, {
                      dressCode: /* BlackOnBlack */0,
                      isSelected: Curry._2(CommonTypes_Shift_DressCode.eq, /* BlackOnBlack */0, dressCode),
                      onClick: updateDressCode
                    }), React.createElement(WebContainers_PostAShift_ShiftDetails$DressCodeButton, {
                      dressCode: /* WhiteOnBlack */1,
                      isSelected: Curry._2(CommonTypes_Shift_DressCode.eq, /* WhiteOnBlack */1, dressCode),
                      onClick: updateDressCode
                    }), React.createElement(WebContainers_PostAShift_ShiftDetails$DressCodeButton, {
                      dressCode: /* Custom */2,
                      isSelected: Curry._2(CommonTypes_Shift_DressCode.eq, /* Custom */2, dressCode),
                      onClick: updateDressCode
                    })), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Subtext.make, {
                  className: descText,
                  children: Relude_Option.fold("", Relude_Globals.id, getDressCodeDescription(dressCode))
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(Curry._1(result, /* Attire */1))(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(function (param) {
                              return Curry._1(blur, /* Attire */1);
                            }), undefined, undefined, undefined, undefined, undefined, "SpecialInstructionsInput", undefined, "Special Attire Notes", undefined, undefined, undefined, undefined), {
                      TAG: /* Text */7,
                      _0: {
                        onChange: (function (param) {
                            return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                          return Relude_IO.map((function (param) {
                                                        return update$1(change, state, param);
                                                      }), param);
                                        }), param);
                          }),
                        value: get$1(state)
                      }
                    }, undefined, undefined, undefined)), Relude_Option.fold(null, (function (param) {
                    var shiftAccessories = param.accessories;
                    if (Curry._1(CommonTypes_ShiftType_Accessory.$$Set.isEmpty, shiftAccessories)) {
                      return null;
                    } else {
                      return React.createElement(React.Fragment, {
                                  children: null
                                }, React.createElement(BrowserComponents_Spacer.make, {
                                      size: /* XXLarge */7
                                    }), React.createElement(WebComponents_PostAShiftForm.Title.make, {
                                      title: "Accessories"
                                    }), React.createElement(BrowserComponents_FlexRow.make, {
                                      className: accessoryContainer,
                                      children: Curry._2(Relude_Array.map, (function (accessory$1) {
                                              return React.createElement(BrowserComponents_Button.Selector.make, {
                                                          className: accessory,
                                                          children: React.createElement(BrowserComponents_Text.make, {
                                                                children: accessory$1.name
                                                              }),
                                                          isSelected: Curry._2(CommonTypes_ShiftType_Accessory.$$Set.contains, accessory$1, accessories),
                                                          onClick: (function (param) {
                                                              return Relude_IO.suspend(function (param) {
                                                                          return toggleAccesory(change, state, accessory$1);
                                                                        });
                                                            })
                                                        });
                                            }), Curry._1(CommonTypes_ShiftType_Accessory.$$Set.toArray, shiftAccessories))
                                    }));
                    }
                  }), Relude_Option.map((function (param) {
                        return param.shiftType;
                      }), basicInfo)), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XXLarge */7
                }), React.createElement(WebComponents_PostAShiftForm.Title.make, {
                  subtitle: "Who's running this shift and how do we contact them?",
                  title: "On-Site Manager"
                }), React.createElement(BrowserComponents_Dropdown.make, tmp), Relude_Option.fold(React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Medium */4
                        }), React.createElement(BrowserComponents_FlexRow.make, {
                          className: managerContainer,
                          children: null
                        }, React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(Relude_Option.isSome(selectedManager) ? undefined : Curry._1(result, /* OnsiteManagerFirstName */4))(undefined, undefined, managerInput, undefined, Relude_Option.isSome(selectedManager), undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(function (param) {
                                          return Curry._1(blur, /* OnsiteManagerFirstName */4);
                                        }), undefined, undefined, undefined, undefined, undefined, "ManagerFirstNameInput", undefined, "First Name", undefined, undefined, undefined, undefined), {
                                  TAG: /* Text */7,
                                  _0: {
                                    onChange: (function (param) {
                                        return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                                      return Relude_IO.map((function (param) {
                                                                    return update$4(change, state, param);
                                                                  }), param);
                                                    }), param);
                                      }),
                                    value: Curry._1(get$4, state)
                                  }
                                }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                              size: /* Medium */4
                            }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(Relude_Option.isSome(selectedManager) ? undefined : Curry._1(result, /* OnsiteManagerLastName */5))(undefined, undefined, managerInput, undefined, Relude_Option.isSome(selectedManager), undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(function (param) {
                                          return Curry._1(blur, /* OnsiteManagerLastName */5);
                                        }), undefined, undefined, undefined, undefined, undefined, "ManagerLastNameInput", undefined, "Last Name", undefined, undefined, undefined, undefined), {
                                  TAG: /* Text */7,
                                  _0: {
                                    onChange: (function (param) {
                                        return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                                      return Relude_IO.map((function (param) {
                                                                    return update$5(change, state, param);
                                                                  }), param);
                                                    }), param);
                                      }),
                                    value: Curry._1(get$5, state)
                                  }
                                }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                              size: /* Medium */4
                            }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(Relude_Option.isSome(selectedManager) ? undefined : Curry._1(result, /* OnsiteManagerPhoneNumber */6))(undefined, undefined, managerInput, undefined, Relude_Option.isSome(selectedManager), undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(function (param) {
                                          return Curry._1(blur, /* OnsiteManagerPhoneNumber */6);
                                        }), undefined, undefined, undefined, undefined, undefined, "ManagerPhoneNumberInput", undefined, "Phone Number", undefined, undefined, undefined, undefined), {
                                  TAG: /* Text */7,
                                  _0: {
                                    onChange: (function (param) {
                                        return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                                      return Relude_IO.map((function (param) {
                                                                    return update$6(change, state, param);
                                                                  }), param);
                                                    }), param);
                                      }),
                                    value: Curry._1(get$6, state)
                                  }
                                }, undefined, undefined, undefined)))), (function (param) {
                    return Relude_Globals.$$const(partial_arg$2, param);
                  }), selectedManager), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XXLarge */7
                }), React.createElement(WebComponents_PostAShiftForm.Title.make, {
                  subtitle: "Let our Professionals know any details about the shift that may require their attention.",
                  title: "Shift Details"
                }), React.createElement(BrowserComponents_Textarea.make, {
                  inputClassName: descriptionInput,
                  onBlur: Relude_IO.suspend(function (param) {
                        return Curry._1(blur, /* Description */7);
                      }),
                  onChange: (function (value) {
                      return Relude_IO.suspend(function (param) {
                                  return update$7(change, state, value);
                                });
                    }),
                  testId: "ShiftDescriptionInput",
                  title: "Details",
                  value: state.description
                }), React.createElement(BrowserComponents_ValidationError.make, {
                  validationResult: Curry._1(result, /* Description */7)
                }));
}

var make = WebContainers_PostAShift_ShiftDetails;

exports.Styles = Styles;
exports.DressCodeButton = DressCodeButton;
exports.Form = Form;
exports.FormContainer = FormContainer;
exports.getSavedManagerOrState = getSavedManagerOrState;
exports.getDressCodeDescription = getDressCodeDescription;
exports.make = make;
/* descText Not a pure module */
